import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import Badge from "reactstrap/es/Badge";
const Context = createContext({});
export function MenuSmartBadge({ id, badgeProps = {} }) {
    const { store } = useContext(Context);
    if (!store[id])
        return null;
    return (_jsx(Badge, Object.assign({ style: { marginLeft: 'auto', width: "auto", paddingLeft: 5, paddingRight: 5 } }, badgeProps, { children: store[id] })));
}
export function useSmartBadgeControls(id) {
    var _a;
    const { store, setStore } = useContext(Context);
    let currentValue = ((_a = store[id]) !== null && _a !== void 0 ? _a : 0);
    return {
        value: currentValue,
        inc: (n = 1) => setStore(state => (Object.assign(Object.assign({}, state), { [id]: Math.max(currentValue + n, 0) }))),
        dec: (n = 1) => setStore(state => (Object.assign(Object.assign({}, state), { [id]: Math.max(currentValue - n, 0) }))),
        set: (val) => setStore(state => (Object.assign(Object.assign({}, state), { [id]: val }))),
    };
}
export function BadgeProvider({ children }) {
    const [store, setStore] = useState({
        requests: 0
    });
    const [retry, setRetry] = useState(0);
    useEffect(() => {
        const sse = new EventSource(`/api/v2/system/badges?retryId=${retry}`);
        sse.addEventListener('snapshot', (event) => {
            const payload = JSON.parse(event.data);
            setStore(payload);
        });
        sse.addEventListener('error', () => {
            if (retry >= 10)
                return false;
            setTimeout(() => {
                setRetry(n => ++n);
            }, 500 * retry);
        });
        return () => {
            sse.close();
        };
    }, [retry]);
    return (_jsx(Context.Provider, Object.assign({ value: { store, setStore } }, { children: children })));
}
